import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";

function TreatmentDrop({ data, onChange, name, label }: any) {
  const [open, setopen] = useState(false);
  const [selected, setselected] = useState("Select");

  const onHandelChange = (e: any) => {
    onChange({
      target: {
        name: name,
        value: e.value,
      },
    });
    setopen(false);
    setselected(e.treatment);
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5 capitalize">{label}</label>
      <button
        type="button"
        onClick={() => setopen((prev) => !prev)}
        className="w-full px-4 py-2.5 rounded-xl border border-gray-600 dark:border-slate-500 border-solid bg-slate-50 dark:bg-slate-700 text-left flex items-center justify-between focus:outline-none transition-all dark:text-slate-200"
      >
        <span className={selected === "Select" ? "text-slate-400 dark:text-slate-500" : "text-slate-800 dark:text-slate-200 font-medium"}>
          {selected}
        </span>
        <KeyboardArrowDownIcon
          className={`text-slate-400 dark:text-slate-500 transition-transform ${open ? "rotate-180" : ""}`}
          sx={{ fontSize: 20 }}
        />
      </button>

      {open && (
        <ul className="absolute z-20 w-full mt-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 rounded-xl shadow-xl dark:shadow-slate-900/50 max-h-64 overflow-y-auto">
          <li
            onClick={() => onHandelChange({ value: "", treatment: "Select" })}
            className="px-4 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer text-sm text-slate-500 dark:text-slate-400 border-b border-slate-100 dark:border-slate-600"
          >
            Select
          </li>
          {data?.map((item: any, i: number) => (
            <li
              key={i}
              onClick={() =>
                onHandelChange({
                  value: item._id + "/" + item.treatment + "/" + item.price,
                  treatment: item.treatment,
                })
              }
              className={`px-4 py-2.5 cursor-pointer flex items-center justify-between border-b border-slate-100 dark:border-slate-600 last:border-0 transition-colors ${
                selected === item.treatment
                  ? "bg-indigo-50 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300"
                  : "hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300"
              }`}
            >
              <span className="text-sm font-medium">{item.treatment}</span>
              <div className="flex items-center gap-2">
                <span className="text-xs px-2 py-0.5 bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 rounded-full font-semibold">
                  Rs {item.price}
                </span>
                {selected === item.treatment && (
                  <CheckIcon className="text-indigo-600 dark:text-indigo-400" sx={{ fontSize: 18 }} />
                )}
              </div>
            </li>
          ))}
       
        </ul>
      )}
    </div>
  );
}

export default TreatmentDrop;
